import { createSelector } from '@reduxjs/toolkit';
import { preferencesSelectors } from 'app-components/flux/preferences';
import store from 'app-components/utils/redux-store';
import { LruObjectCache, createCachedSelector } from 're-reselect';
import createTheme from './createTheme';
import { isLightThemeKey } from './themeHint';

export const getThemeByKey = createCachedSelector(
  (themeKey) => themeKey || '',
  (themeKey) => createTheme(isLightThemeKey(themeKey) ? 'light' : 'dark'),
)({
  keySelector: (themeKey) => themeKey || '',
  cacheObject: new LruObjectCache({ cacheSize: 5 }),
});

export const getThemeKey = (state) =>
  (preferencesSelectors.getSharedPreferencesByPath(state, { group: 'dataset', path: ['webApp'] }) || {}).theme;

// The theme key lives in the dataset preferences, so it isn't known until they load (or are set).
export const getIsThemeKeyLoaded = (state) => preferencesSelectors.getLoadPendingState(state).shared.dataset === false;

export const getCurrentTheme = createSelector(
  (state) =>
    (preferencesSelectors.getSharedPreferencesByPath(state, { group: 'dataset', path: ['webApp'] }) || {}).theme,
  (themeKey) => getThemeByKey(themeKey),
);

// don't use this method, unless you know what you are doing
export const dangerouslyGetTheme = () => {
  const state = store.getState();
  const datasetPreferences =
    state && preferencesSelectors.getSharedPreferencesByPath(state, { group: 'dataset', path: ['webApp'] });
  const themeKey = datasetPreferences && datasetPreferences.theme;
  return getThemeByKey(themeKey);
};
